import { cleanDictForJson } from 'utils/secure-json';
import Concept from 'components/landing/home-landing/concept/concept';
import Coverage from 'components/landing/home-landing/coverage/coverage';
import CTABannerContainer from 'components/home/cta-sticky-banner/cta-banner-container';
import CultureShow from 'core/culture-show';
import CustomHead from 'core/custom-head';
import Faq from 'components/landing/faq/faq';
import Footer from 'components/footer/footer';
import getConstants from 'utils/query-data-parser/landing/get-constant';
import Guide from 'components/landing/guide/guide';
import Header from 'components/home/header';
import { Header as HeaderSection } from 'components/landing/home-landing/header/header';
import HowMuch from 'components/landing/home-landing/how_much/how_much';
import InsuranceDescription from 'components/landing/home-landing/insurance-description/insurance-description';
import InsuranceResult from 'components/landing/home-landing/insurance-result/insurance-result';
import InsuranceSliderContainer from 'components/landing/insurance-slider/insurance-slider-container';
import InsuranceTypes from 'components/landing/home-landing/insurance-types/insurance-types';
import { PageInfoContextProvider } from 'context/PageInfoContext';
import PropTypes from 'prop-types';
import ScriptContainer from 'components/container/script-container';
import Scroller from 'components/home/scroller';
import SeoTracking from 'components/seo/tracking/seo-tracking';
import TableLinkComponent from 'components/landing/index/table-link-component';
import TableResume from 'components/landing/index/table-resume';
import WhoNeeds from 'components/landing/home-landing/who_needs/who_needs';
import withHydrationOnDemand from 'react-hydration-on-demand';

const InsuranceSliderContainerH = withHydrationOnDemand({ on: ['visible'] })(InsuranceSliderContainer);
const CoverageH = withHydrationOnDemand({ on: ['visible'] })(Coverage);
const ConceptH = withHydrationOnDemand({ on: ['visible'] })(Concept);
const GuideH = withHydrationOnDemand({ on: ['visible'] })(Guide);
const HowMuchH = withHydrationOnDemand({ on: ['visible'] })(HowMuch);
const WhoNeedsH = withHydrationOnDemand({ on: ['visible'] })(WhoNeeds);
const InsuranceTypesH = withHydrationOnDemand({ on: ['visible'] })(InsuranceTypes);
const InsuranceDescriptionH = withHydrationOnDemand({ on: ['visible'] })(InsuranceDescription);
const InsuranceResultH = withHydrationOnDemand({ on: ['visible'] })(InsuranceResult);
const FaqH = withHydrationOnDemand({ on: ['visible'] })(Faq);
const FooterH = withHydrationOnDemand({ on: ['visible'] })(Footer);

const InsuranceHome = ({ culture, payload }) => {
    return (
        <ScriptContainer breadcrumbList={payload.page_context.page_breadcrumb_list}>
            <SeoTracking
                templateName="contentap"
                pageCode={payload.page_context.code}
            />
            <CustomHead pageInfo={payload} />
            <PageInfoContextProvider data={payload}>
                <>
                    <CTABannerContainer
                        hideMobile
                        redirectWithConversio
                        formType="home"
                        culture={culture}
                        showLeadFormCondition={culture !== 'es-ar'}
                        productVertical={
                            payload.page_context.page_dinamic_data
                                .product_vertical
                        }
                    />
                    <Scroller />
                    <Header />
                    <HeaderSection />
                    <TableResume showBreadcrumb>
                        <InsuranceSliderContainerH redirectWithConversio culture={culture} />
                        <CultureShow cultures={['es-ar']} culture={culture}>
                            <InsuranceResultH
                                seoKeyword={payload.page_context.page_dinamic_data.seo_keyword}
                                culture={culture}
                            />
                        </CultureShow>
                        <TableLinkComponent id="c" titleList={[1]}>
                            <CoverageH culture={culture} />
                        </TableLinkComponent>
                        <TableLinkComponent id="ic" titleList={[2, 3]}>
                            <ConceptH />
                        </TableLinkComponent>
                        <TableLinkComponent id="hm" titleList={[4, 5, 6]}>
                            <HowMuchH
                                data={
                                    payload.page_context.page_dinamic_data
                                        .best_price_coverage_list
                                }
                                culture={culture}
                            />
                        </TableLinkComponent>
                        <TableLinkComponent id="wn" titleList={[7]}>
                            <WhoNeedsH culture={culture} />
                        </TableLinkComponent>
                        <TableLinkComponent id="it" titleList={[8]}>
                            <InsuranceTypesH culture={culture} />
                        </TableLinkComponent>
                        <TableLinkComponent id="id" titleList={[9]}>
                            <InsuranceDescriptionH />
                        </TableLinkComponent>
                        <GuideH
                            data={
                                payload.page_context.page_dinamic_data
                                    .guide_list
                            }
                        />
                        <FaqH redirectWithConversio culture={culture} />
                        <FooterH />
                    </TableResume>
                </>
            </PageInfoContextProvider>
        </ScriptContainer>
    );
};

export async function getServerSideProps ({ req }) {
    const data = req.apiData.data;
    const culture = data.page_context.page_lang;

    const payload = {
        ...data,
        ...getConstants(data.page_context)
    };

    return {
        props: {
            messages: (
                await import(`../messages/insurance-home/${culture}.json`)
            ).default,
            payload: cleanDictForJson(payload),
            culture,
            locale: culture.split('-')[1],
            timeZone: req.apiData.timeZone
        }
    };
}

InsuranceHome.propTypes = {
    payload: PropTypes.object,
    culture: PropTypes.string
};

export default InsuranceHome;
